'use client';

import { Icon } from '@/general/Icons/Icon';
import { clsx } from 'clsx';
import { FC } from 'react';

import { Button } from '@/general/components/Button/Button';

import { ButtonIcon } from '../Button/ButtonIcon';

interface Props {
  page: number;
  type: 'page' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis';
  selected: boolean;
  href?: string;
  rel?: string;
}

export const PaginationButton: FC<Props> = ({ page, type, selected, href, rel }) => {
  if (type === 'start-ellipsis' || type === 'end-ellipsis') {
    return <div className="Pagination-ellipsis">&hellip;</div>;
  }
  if (type === 'page') {
    return (
      <Button
        href={href}
        rel={rel}
        disabled={!href}
        className={clsx('Pagination-button', { 'Pagination-currentPage': selected })}
        data-testid={`Pagination-component-button-${page}`}
        variant="tertiary"
        size="small"
      >
        {page}
      </Button>
    );
  }
  if (type === 'previous') {
    return (
      <>
        <ButtonIcon
          href={href}
          rel={rel}
          disabled={!href}
          className={clsx('Pagination-button', 'Pagination-buttonPrevNext', 'Pagination-buttonPrevNext-icon')}
          data-testid="Pagination-component-button-prev"
          variant="tertiary"
          size="small"
          title="Previous page"
          icon={<Icon name="caret-left" />}
        />
        <Button
          href={href}
          rel={rel}
          disabled={!href}
          className={clsx('Pagination-button', 'Pagination-buttonPrevNext', 'Pagination-buttonPrevNext-text')}
          data-testid="Pagination-component-button-prev"
          variant="tertiary"
          size="small"
          startIcon={<Icon name="caret-left" />}
          title="Previous page"
        >
          Prev
        </Button>
      </>
    );
  }
  if (type === 'next') {
    return (
      <>
        <ButtonIcon
          href={href}
          rel={rel}
          disabled={!href}
          className={clsx('Pagination-button', 'Pagination-buttonPrevNext', 'Pagination-buttonPrevNext-icon')}
          data-testid="Pagination-component-button-next"
          variant="tertiary"
          size="small"
          title="Next page"
          icon={<Icon name="caret-right" />}
        />
        <Button
          href={href}
          rel={rel}
          disabled={!href}
          className={clsx('Pagination-button', 'Pagination-buttonPrevNext', 'Pagination-buttonPrevNext-text')}
          data-testid="Pagination-component-button-next"
          variant="tertiary"
          size="small"
          endIcon={<Icon name="caret-right" />}
          title="Next page"
        >
          Next
        </Button>
      </>
    );
  }
  return null;
};
